import { testimonialConstants } from "../actions/constants/testimonialConstant";

const testimonialData = (state = { status: "", message: "" }, action: any) => {
	switch (action.type) {
		case testimonialConstants.Testimonial_GetByFilter_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isListSuccess: false,
			};
		case testimonialConstants.Testimonial_GetByFilter_Success:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isListSuccess: true,
				items: action.payload
			};
		case testimonialConstants.Testimonial_GetByFilter_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isListSuccess: false,
			};

		case testimonialConstants.TestimonialDetailRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case testimonialConstants.TestimonialDetailSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				testimonialInput: action.payload?.messageDTO,
			};
		case testimonialConstants.TestimonialDetailFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload,
			};

		case testimonialConstants.TestimonialStatusUpdateRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isUpdateStatus: false,
			};
		case testimonialConstants.TestimonialStatusUpdateSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isUpdateStatus: true,
				status: action.payload.message,
			};
		case testimonialConstants.TestimonialStatusUpdateFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUpdateStatus: true,
				status: action.payload,
			};

		case testimonialConstants.TestimonialVideoStatusUpdateRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isUpdateStatus: false,
			};
		case testimonialConstants.TestimonialVideoStatusUpdateSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isUpdateStatus: true,
				status: action.payload.message,
			};
		case testimonialConstants.TestimonialVideoStatusUpdateFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUpdateStatus: true,
				status: action.payload,
			};

		default:
			return state;
	}
};

export default testimonialData;
